import { useState } from "react";
import { useNavigate } from "react-router";
import dayjs, { Dayjs } from "dayjs";
import { CSVLink } from "react-csv";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useAuth } from "../components/AuthProvider.tsx";
import Moment from "moment-timezone";
import ApplicationSearch from "../models/ApplicationSearch.tsx";
import ApplicationItem from "../models/ApplicationItem.tsx";
import MenuComponent from "../components/Menu.tsx";
import CalendarIcon from "../components/CalendarIcon.tsx";

function AdminSearch() {
  const NewSearch = () => {
    const search:ApplicationSearch = {
      Token: "",
      StartOn: "",
      EndOn: "",
      DateType: "",
      ApplicationStatusId: null,
      JobNumber: "",
      DesignationNumber: "",
      OperatingName: "",
      BusinessFirstName: "",
      BusinessLastName: "",
      ApplicationFirstName: "",      
      ApplicationLastName: "",
      OperatingSectorId: null,
      BusinessSizeId: null,
      YearsOfOperationId: null
    }
    return search;
  }

  const navigate = useNavigate();
  const { authorization, SetAuthorization } = useAuth();
  const [search, SetSearch] = useState(NewSearch());
  const [applications, SetApplications] = useState<ApplicationItem[]>([]);
  const [startOn, SetStartOn] = useState<Dayjs | null>();
  const [endOn, SetEndOn] = useState<Dayjs | null>();
  
  const Submit = (event: React.ChangeEvent<any>) => {
    event.preventDefault();
    
    search.Token = authorization.Token;
    search.StartOn = startOn && Moment(startOn?.toDate()).isValid() ? Moment.tz(startOn?.toDate(), Moment.tz.guess()).tz("America/Chicago").format("MMM DD, yyyy"): "";
    search.EndOn = endOn && Moment(endOn?.toDate()).isValid() ? Moment.tz(endOn?.toDate(), Moment.tz.guess()).tz("America/Chicago").format("MMM DD, yyyy"): "";
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(search)
    };

    fetch("/api/search", options)
      .then(response => response.json())
      .then(data => SetApplications(data))
      .catch(error => console.error(error));
  }

  const Export = () => {
    search.Token = authorization.Token;
    search.StartOn = startOn && Moment(startOn?.toDate()).isValid() ? Moment.tz(startOn?.toDate(), Moment.tz.guess()).tz("America/Chicago").format("MMM DD, yyyy"): "";
    search.EndOn = endOn && Moment(endOn?.toDate()).isValid() ? Moment.tz(endOn?.toDate(), Moment.tz.guess()).tz("America/Chicago").format("MMM DD, yyyy"): "";
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(search)
    };

    fetch("/api/export", options)
      .then(response => response.json())
      .then(data => alert("Test"))
      .catch(error => console.error(error));
  }

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    SetSearch((prevState) => ({ ...prevState, [name]: value }));
  }

  const headers = [
    { label: "Application Number", key: "JobNumber" },
    { label: "Status", key: "Status" },
    { label: "Actioned by", key: "ModifiedBy" },
    { label: "Employer Business Name", key: "Employer" },
    { label: "Designation Number", key: "DesignationNumber" },
    { label: "Location", key: "Location" },
    { label: "Employer Contact Name", key: "EmployerName" },
    { label: "Applicant Last Name", key: "Applicant_LastName" },
    { label: "Job Title", key: "JobTitle" },
    { label: "Main Operating Sector", key: "OperatingSector" },
    { label: "Size of Business", key: "BusinessSize" },
    { label: "Years in Operation", key: "YearsOfOperation" },
    { label: "IP", key: "IP" }
  ];

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MenuComponent page={"Application Search"} />
      <section id="main">
        <div className="container">
          <form onSubmit={Submit}>
            <p className="half">
              <label>Search from date<br/>
                <DatePicker value={startOn} onChange={(newValue) => SetStartOn(newValue)} slots={{ openPickerIcon: CalendarIcon }} />
              </label>
              <label>Search to date<br/>
                <DatePicker value={endOn} onChange={(newValue) => SetEndOn(newValue)} slots={{ openPickerIcon: CalendarIcon }} />
              </label>
            </p>
            <p>
              <label>Search Date By
                <span className="doubleSearch">
                  <label htmlFor="create" className="form-control"><input type="radio" id="create" name="DateType" value="createdOn" onChange={OnChange} />Create Date</label>
                  <label htmlFor="modify" className="form-control"><input type="radio" id="modify" name="DateType" value="modifiedOn" onChange={OnChange} />Last Modified Date</label>
                </span>
              </label>
            </p>
            <p className="half">
              <label>Application Status
                <select name="ApplicationStatusId" value={search.ApplicationStatusId} onChange={OnChange}>
                  <option value="">All</option>
                  <option value="1">Submitted</option>
                  <option value="2">Under Review</option>
                  <option value="3">Incomplete</option>
                  <option value="4">Complete</option>
                  <option value="5">Decline To Recommend</option>
                  <option value="6">Withdrawn</option>
                  <option value="7">Ineligible</option>
                  <option value="8">Recommended</option>
                </select>
              </label>
            </p>
            <p>
              <label>Application Number
                <input type="text" name="JobNumber" value={search.JobNumber} onChange={OnChange} />
              </label>    
            </p>
            <p>
              <label>Designation Number
                <input type="text" name="DesignationNumber" value={search.DesignationNumber} onChange={OnChange} />
              </label>    
            </p>
            <p>
              <label>Employer Organization Name
                <input type="text" name="OperatingName" value={search.OperatingName} onChange={OnChange} />
              </label>
            </p>
            <p>
              <label>Employer First Name
                <input type="text" name="BusinessFirstName" value={search.BusinessFirstName} onChange={OnChange} />
              </label>
            </p>            
            <p>
              <label>Employer Last Name
                <input type="text" name="BusinessLastName" value={search.BusinessLastName} onChange={OnChange} />
              </label>
            </p>
            <p>
              <label>Applicant First Name
                <input type="text" name="ApplicationFirstName" value={search.ApplicationFirstName} onChange={OnChange} />
              </label>
            </p>            
            <p>
              <label>Applicant Last Name
                <input type="text" name="ApplicationLastName" value={search.ApplicationLastName} onChange={OnChange} />
              </label>
            </p>
            <p className="half">
              <label>Main Operating Sector
                <select name="OperatingSectorId" value={search.OperatingSectorId} onChange={OnChange}>
                  <option value="">All</option>
                  <option value="6">Business, finance and administration</option>
                  <option value="1">Education, law and social, community and government services</option>
                  <option value="2">Health</option>
                  <option value="3">Manufacturing and utilities</option>
                  <option value="4">Sales and service</option>
                  <option value="5">Trades and transport</option>
                </select>
              </label>
            </p>
            <p className="half">
              <label>Size of Business
                <select name="BusinessSizeId" value={search.BusinessSizeId} onChange={OnChange}>
                  <option value="">All</option>
                  <option value="1">Under 10 employees</option>
                  <option value="2">Under 30 employees</option>
                  <option value="3">Under 50 employees</option>
                  <option value="4">50 employees or more</option>
                </select>
              </label>
            </p>
            <p className="half">
              <label>Years In Operation
                <select name="YearsOfOperationId" value={search.YearsOfOperationId} onChange={OnChange}>
                  <option value="">All</option>
                  <option value="1">Under 2 years</option>
                  <option value="2">2 to 5 years</option>
                  <option value="3">Over 5 years</option>
                </select>
              </label>
            </p>
            <p className="formButton"><input type="submit" value="Search Applications" /></p> 
            {applications.length > 0 && <p className="formButton"><CSVLink data={applications} headers={headers} filename="applications.csv">Export Applications</CSVLink></p>}
          </form>

          <div className="appList admApp">
            <article>
              <div></div>
              <div>Application #</div>
              <div>Employer</div>
              <div>Create Date</div>
              <div>Last Revised</div>
              <div>Actioned by</div>
            </article>

            {applications.map(application => (
              <article key={application.ApplicationId}>
                <div>
                  <ul>
                    <li><a onClick={() => navigate("/admin/application/" + application.ApplicationId)}><img src="/images/icon-edit.png" alt="Edit Application" title="Edit Application" /></a></li>
                    <li>
                      <span className="tooltip">
                        {application.ApplicationStatusId == 1 && <><img src="/images/Submitted.png" alt="Submitted" /><span className="tooltiptext">Submitted</span></>}
                        {application.ApplicationStatusId == 2 && <><img src="/images/Under-Review.png" alt="Under Review" /><span className="tooltiptext">Under Review</span></>}
                        {application.ApplicationStatusId == 3 && <><img src="/images/Incomplete.png" alt="Incomplete" /><span className="tooltiptext">Incomplete</span></>}
                        {application.ApplicationStatusId == 4 && <><img src="/images/Complete.png" alt="Complete" /><span className="tooltiptext">Complete</span></>}
                        {application.ApplicationStatusId == 5 && <><img src="/images/Decline-Recommend.png" alt="Declined to Recomment" /><span className="tooltiptext">Decline to Recommend</span></>}
                        {application.ApplicationStatusId == 6 && <><img src="/images/Withdrawn.png" alt="Withdrawn" /><span className="tooltiptext">Withdrawn</span></>}
                        {application.ApplicationStatusId == 7 && <><img src="/images/Ineligible.png" alt="Ineligible" /><span className="tooltiptext">Ineligible</span></>}
                        {application.ApplicationStatusId == 8 && <><img src="/images/Recommended.png" alt="Recommended" /><span className="tooltiptext">Recommended</span></>}
                      </span>
                    </li>
                  </ul>
                </div>
                <div>{application.JobNumber}</div>
                <div>{application.Employer}</div>
                <div>{Moment.tz(application.CreatedOn, "America/Chicago").tz(Moment.tz.guess()).format("MMM DD, yyyy")}</div>
                <div>{Moment.tz(application.ModifiedOn, "America/Chicago").tz(Moment.tz.guess()).format("MMM DD, yyyy")}</div>
                <div>{application.ModifiedBy}</div>
                <div></div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </LocalizationProvider>
  );
}

export default AdminSearch;